import {
	DomainUsersByCompanyActionTypes,
	DomainUsersByCompanyState,
	DomainUsersByCompanyTypes,
} from "./domainUsersByCompanyTypes";
import { Action } from "redux-saga";

const INITIAL_STATE: DomainUsersByCompanyState = {
	domainUsersByCompany: {
		data: null,
		isLoading: false,
		isError: false,
		errorMessages: null,
	},
};

function domainUsersByCompanyReducer(state = INITIAL_STATE, action: Action) {
	const actionTypes = action as DomainUsersByCompanyActionTypes;
	switch (actionTypes.type) {
		case DomainUsersByCompanyTypes.GET_DOMAIN_USERS_BY_COMPANY:
			return {
				...state,
				domainUsersByCompany: {
					...state.domainUsersByCompany,
					isLoading: true,
					isError: false,
					errorMessages: null,
				},
			};
		case DomainUsersByCompanyTypes.SAVE_DOMAIN_USERS_BY_COMPANY:
			return {
				...state,
				domainUsersByCompany: {
					data: actionTypes.payload.data,
					isError: actionTypes.payload.isError,
					errorMessages: actionTypes.payload.errorMessages,
					isLoading: false,
				},
			};
		case DomainUsersByCompanyTypes.RESET_REDUCER_DOMAIN_USERS_BY_COMPANY:
			return {
				...state,
				domainUsersByCompany: INITIAL_STATE.domainUsersByCompany,
			};
		default:
			return state;
	}
}

export default domainUsersByCompanyReducer;
